//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------
// -- CheckList -------------------

export const listStoryWithAi = (returnedPayload) => ({ type: ActionTypes.StoryWithAi.listStoryWithAi, payload: returnedPayload });
export const addStoryWithAi = (returnedPayload) => ({ type: ActionTypes.StoryWithAi.addStoryWithAi, payload: returnedPayload });
export const deleteStoryWithAi = (returnedPayload) => ({ type: ActionTypes.StoryWithAi.deleteStoryWithAi, payload: returnedPayload });
export const updateStoryWithAi = (returnedPayload) => ({ type: ActionTypes.StoryWithAi.updateStoryWithAi, payload: returnedPayload });
export const addOrUpdateAiStory = (returnedPayload) => ({ type: ActionTypes.StoryWithAi.addOrUpdateAiStory, payload: returnedPayload });
export const createClassStory = (returnedPayload) => ({ type: ActionTypes.StoryWithAi.createClassStory, payload: returnedPayload });

//article list

export const listArticleLevel = (returnedPayload) => ({ type: ActionTypes.article_level.list_article_level, payload: returnedPayload });
export const addArticleLevel = (returnedPayload) => ({ type: ActionTypes.article_level.create_article_level, payload: returnedPayload });
export const deleteArticleLevel = (returnedPayload) => ({ type: ActionTypes.article_level.delete_article_level, payload: returnedPayload });
export const updateArtitclelevel = (returnedPayload) => ({ type: ActionTypes.article_level.update_article_level, payload: returnedPayload });
export const addOrUpdateArticleLevel = (returnedPayload) => ({ type: ActionTypes.article_level.addOrUpdateArticleLevel, payload: returnedPayload });
export const createArticleLevel = (returnedPayload) => ({ type: ActionTypes.article_level.create_article_level, payload: returnedPayload });